module.exports = __webpack_public_path__ + "img/problem_cover_03.f81a017e.jpg";